export const GLEAP_UPGRADE_ACCOUNT_FORM_KEY = '826446735ed21eec4e70';
export const GLEAP_TAILOR_PLAN_FORM_KEY = 'dc679218c291001857e6';
export const GLEAP_CARD_FAILED_FORM_KEY = '6df1e3c993410480f095';
export const GLEAP_PARTNERSHIP_ADDON_FORM_KEY = 'ee9c38c328dd16cb9251';
export const GLEAP_PARTNERSHIP_UPGRADE_FORM_KEY = '217f43f8aaa8dbbc3b69';
export const GLEAP_NEW_AND_RETURNING_SWITCH_FORM_KEY = '3bf3bd5fa925186e9864';
export const GLEAP_CONNECTED_ACCOUNT_LIMIT_FORM_KEY = 'f2eb80c14e41846b182b';
export const GLEAP_INBOX_SYNC_FAILED_FORM_KEY = '15445558b4b0ee33e92a';
export const GLEAP_EMAIL_CONNECTION_FAILURE_FORM_KEY = '2ad41db3fb98d3a9b636';

// Gleap form attributes accessible at https://app.gleap.io/projects/67335a8cb3d5df951fcb7600/bots/forms
export const GLEAP_FORM_ATTRIBUTES = {
  EMAIL_CONNECTION_FAILED: '0gkyzi',
  INBOX_SYNC_FAILED: 'yjtar',
} as const;
